div:has(> .curriculum) {
    /* The div around the curriculum app should be full width */
    width: 100%;
}

.curriculum {
    /* SVG is used for custom dashed border instead of border-style: dashed - https://kovart.github.io/dashed-border-generator/ */
    --dashed-border: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%230a64ff' stroke-width='2' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");

    margin: 0 auto;
    background-color: var(--bi-primary-100);
    color: var(--bi-basic-white);
    font: var(--bi-font-body-large);

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: var(--bi-scale-12x);
        background-color: inherit;

        h2 {
            font: var(--bi-font-title-bold-medium);
            color: var(--bi-color-text-accent);
        }
    }

    .controls {
        display: flex;
        align-items: center;
        gap: var(--bi-scale-6x);
        flex-shrink: 0;
        max-width: 50%;

        .optionTrigger {
            flex-shrink: 1;
        }

        .optionText,
        .chosenOption {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .chosenOption {
            font: var(--bi-font-label-medium);
        }
    }

    > .description {
        margin: var(--bi-scale-4x) 0 var(--bi-scale-8x);
    }

    > .chooseOption {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: var(--bi-scale-36x);
        margin: var(--bi-scale-8x) 0 var(--bi-scale-2x);
        padding: var(--bi-scale-2x) var(--bi-scale-3x);
        background: var(--dashed-border);
        border-radius: var(--bi-radius-medium);
    }

    .sticky {
        height: var(--bi-scale-12x);
        background-color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        max-width: 100dvw;
        width: calc(100% + var(--product-page-content-bleed) * 2);
        margin: 0 calc(var(--product-page-content-bleed) * -1);

        &.notStickyOnMobile {
            @media (width < 1024px) {
                position: unset;
            }
        }

        > :first-child {
            padding: 0 var(--product-page-content-bleed);
        }
        > .tabsRow {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: var(--bi-scale-2x);

            > :global(.bi-tabs) {
                @media (width < 768px) {
                    --bic-tabs-tab-padding: 0.625rem var(--bi-scale-3x);
                }
            }
        }
        > hr {
            margin: 0;
            border: 0;
            border-bottom: 1px solid var(--bi-color-stroke-basic-subtle);
        }
    }

    .viewport {
        --slide-size: 100%;
        --slide-spacing: var(--bi-scale-8x);

        overflow: hidden;
        /* The slides side by side add up to a min-content wider than the screen, which would otherwise widen the
        page's grid column with it. */
        contain: inline-size;

        .container {
            display: flex;
            align-items: flex-start;
            touch-action: pan-y pinch-zoom;
            margin-left: calc(var(--slide-spacing) * -1);

            .slide {
                flex: 0 0 var(--slide-size);
                min-width: 0;
                padding: var(--bi-scale-8x) 0 var(--bi-scale-2x) var(--slide-spacing);
                display: flex;
                flex-direction: column;
                gap: var(--bi-scale-8x);
            }
        }
    }
}
